import { render, staticRenderFns } from "./SizeSelector.vue?vue&type=template&id=496d434a&scoped=true"
import script from "./SizeSelector.vue?vue&type=script&lang=js"
export * from "./SizeSelector.vue?vue&type=script&lang=js"
import style0 from "./SizeSelector.vue?vue&type=style&index=0&id=496d434a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496d434a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('496d434a')) {
      api.createRecord('496d434a', component.options)
    } else {
      api.reload('496d434a', component.options)
    }
    module.hot.accept("./SizeSelector.vue?vue&type=template&id=496d434a&scoped=true", function () {
      api.rerender('496d434a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chart/components/shapeAttr/SizeSelector.vue"
export default component.exports